export const mapAssetStatuses = statuses => {
    const mappedStatuses = Object.entries(statuses).reduce((acc, [key, value]) => ({ ...acc, [key]: value.status }), {});
    return mappedStatuses;
};
